import { getChallengeId, setChallengeId } from 'src/app/auth/cookies';
import { useRouter } from 'next/router';

export const useChallengeCookie = () => {
  const router = useRouter();
  const { query } = router;

  const utm_campaign = query?.utm_campaign || query?.c;

  const challengeIdCookie = getChallengeId();

  if (!utm_campaign?.includes('challenge')) {
    return;
  }

  const utm_campaign_arr =
    typeof utm_campaign === 'string' ? utm_campaign?.split('/') : [];

  if (utm_campaign_arr.length > 0) {
    const challengeId = utm_campaign_arr[1];

    if (!challengeIdCookie) {
      setChallengeId(challengeId);
    }

    if (challengeIdCookie && challengeId !== challengeIdCookie) {
      setChallengeId(challengeId);
    }
  }
};
